import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { EquipoTrabajoService } from 'src/app/services/equipo-trabajo/equipo-trabajo.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
public teams= []
  constructor(private router: Router, public _authService: AuthService,
    private _equipoTrabajoService: EquipoTrabajoService,) { }

  ngOnInit(): void {
    this._equipoTrabajoService.random().subscribe((res: any) => {
      res.lista.forEach((item) => {


        this.teams.push({
          img: null,
          name: item.nombre,
          position: item.puesto,
          facebook: item.facebook,
          whatsapp: item.whatsapp,
        });
      });
    });
  }

  scroll(id) {
    console.log(`scrolling to ${id}`);
    this.router.navigate(['/home']).then(() => {
      let el = document.getElementById(id);
      el.scrollIntoView();
    });
  }
  logout() {
    this._authService.logout();
  }
}
